// extracted by mini-css-extract-plugin
export default {"wrapper":"Notifications_wrapper__cn9Ka","segmented":"Notifications_segmented__+bnWq"};